import { Suspense, useEffect } from "react"
import { ChatInput } from "@/modules/chats/components/chat-input/chat-input"
import { ChatAutoTranslationHeader } from "@/modules/chats/components/chat-message/chat-auto-translation-header"
import { ChatList } from "@/modules/chats/components/chat-message/chat-list"
import { useChatMessagesQueryLoader } from "@/modules/chats/services/useChatMessagesQuery"
import { ChatThread } from "@/modules/chats/types/chat-thread"

interface ChatPanelProps {
  selectedThread: ChatThread
}

export const ChatPanel = ({ selectedThread }: ChatPanelProps) => {
  const [queryRef, loadQuery] = useChatMessagesQueryLoader()

  useEffect(() => {
    loadQuery({ threadId: selectedThread.id }, { fetchPolicy: "network-only" })
  }, [loadQuery, selectedThread.id])

  return (
    <div className="w-min-[400px] bg-surface flex h-full w-full flex-col">
      <Suspense fallback={null}>
        <ChatAutoTranslationHeader thread={selectedThread} />
      </Suspense>
      <div className="z-0 grid min-h-0 flex-1 grid-rows-1" data-testid={`chat-thread-content-${selectedThread.id}`}>
        {queryRef && (
          <Suspense fallback={null}>
            <ChatList queryRef={queryRef} selectedThread={selectedThread} />
          </Suspense>
        )}
      </div>
      <div className="border-t-border bg-surface border-t p-4">
        <ChatInput key={selectedThread.id} selectedThread={selectedThread} />
      </div>
    </div>
  )
}
